import styled from "styled-components";

export const SMaintenanceWarningModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;
